<div class="admin-login-page">
  <div class="login-card">
    
    <div class="login-logo-wrap">
      <img src="/Ambition_built_logo.png" alt="Ambition Built Admin Portal" class="admin-login-logo">
      <span class="portal-badge">ADMIN PORTAL</span>
    </div>

    <h2 class="title">PORTFOLIO MANAGEMENT SYSTEM</h2>
    <p class="subtitle">Log in to manage architectural projects, video films, and image galleries.</p>

    @if (errorMessage()) {
      <div class="error-banner">
        {{ errorMessage() }}
      </div>
    }

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label>USERNAME</label>
        <input type="text" formControlName="username" placeholder="Enter username">
      </div>

      <div class="form-group">
        <label>PASSWORD</label>
        <input type="password" formControlName="password" placeholder="Enter password">
      </div>

      <button type="submit" class="btn-gold login-btn">
        LOG IN TO DASHBOARD
      </button>
    </form>

  </div>
</div>
